function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "send-alt",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon multi-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {
      strokeWidth: 2
    },
    id: titleId
  }, "send alt") : title ? /*#__PURE__*/React.createElement("title", {
    style: {
      strokeWidth: 2
    },
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "secondary-fill",
    d: "M20.35,6l-5.1,14.27a1,1,0,0,1-1.95,0l-2.51-6.52a1,1,0,0,0-.6-.6L5,11.21,19.27,6.12A2,2,0,0,1,20.35,6Z",
    style: {
      fill: "rgb(44, 169, 188)",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-stroke",
    d: "M20.94,4.39,20.35,6l-5.1,14.27a1,1,0,0,1-1.95,0l-2.51-6.52a1,1,0,0,0-.6-.6L5,11.21,3.67,10.7a1,1,0,0,1,0-1.95L19.61,3.06A1,1,0,0,1,20.94,4.39Zm-10.32,9,3-3",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendAlt);
export default __webpack_public_path__ + "static/media/send-alt.a0009b645cf827cbc57c756c22862942.svg";
export { ForwardRef as ReactComponent };